import React, { useContext, createContext, useCallback, useState } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import useLocalStorage from 'react-use/lib/useLocalStorage.js';
import { getDisplayName } from 'recompose';
import {
  SIGN_IN,
  PASSWORD_RESET,
  PASSWORD_FORGET,
  ORG_SHOW_MODERATE,
  ORG_SHOW_EDIT,
  ORG_ONE_TO_MANY_HOME,
  ORG_ONE_TO_ONE_HOME,
  DOWNLOAD_APP_WITH_PRODUCT,
  ORG_401,
  UPSELL_ROUTES,
  ORG_THEME,
  PRODUCT_SCRAPER_TEST_PAGE,
  UGC_RIGHTS_MGMT,
  NO_TEAM,
  START_TRIAL,
  ORG_AGENT_TOOL,
  ORG_ONE_TO_MANY_THEMING,
  ORG_EMBED_STATS,
  ORG_ON_DEMAND_HOME,
  GLOBAL,
  CLIENTS,
  SAML_PROVIDERS,
  DASHBOARD_TRANSLATIONS,
  ORG_ON_DEMAND_VIDEOS,
  ORG_ON_DEMAND_VIDEO_SETUP,
  ORG_ON_DEMAND_PRODUCTS,
  ORG_ON_DEMAND_PRODUCT_SETUP,
  ORG_ON_DEMAND_DISTRIBUTION_PAGES,
  ORG_ON_DEMAND_DISTRIBUTION_CONTAINERS,
  ORG_ON_DEMAND_DISTRIBUTION_CONTAINER,
  ORG_ON_DEMAND_GET_STARTED,
  ORG_ON_DEMAND_ACTIONS,
  ORG_ON_DEMAND_VIDEOS_EDIT_NEW,
  ORG_ON_DEMAND_PLAYLISTS,
  ORG_ON_DEMAND_PLAYLISTS_EDIT,
  ORG_ON_DEMAND_PLACEMENTS,
  ORG_ON_DEMAND_PLACEMENTS_EDIT,
  ORG_ON_DEMAND_APPEARANCES,
  ORG_ON_DEMAND_APPEARANCES_EDIT,
  CLIENT_USAGE,
  ORG_LOCALIZATION,
  ORG_LOCALIZATION_EDIT,
  PRODUCT_ROUTES,
  ORG_ON_DEMAND_THEMING,
  ORG_ON_DEMAND_ACTIONS_SETUP,
  ORG_CALL_BOOKING_SERVICES,
  ORG_API_KEYS,
  ORG_DATA_EXPORT_JOBS,
  ORG_ON_DEMAND_DATA_EXPORT_JOBS,
  ORG_FLOATING_WIDGET,
  ORG_FLOATING_WIDGET_SETTINGS,
  EMAIL_NOTIFICATIONS_UNSUBSCRIBED,
  ORG_USERS,
  CLIENT_USERS,
  ORG_STATS,
  ORG_PRODUCT_FEED,
  ORG_PRODUCT_FEED_ID,
  ORG_CALL_INSIGHTS,
  ORG_PRODUCTS,
  ORG_PRODUCTS_ID,
} from '../constants/routes.js';

import { SUB_PAGE_WIDTHS } from 'components-v3/ProductsNavigation/constants.js';

const defaultValue = {
  isTopbarShown: true,
  isSidebarShown: true,
  isFooterShown: false,
};

export const NavigationFrameContext = createContext(defaultValue);

const COMMON_HIDDEN_ROUTES = [
  SIGN_IN,
  PASSWORD_RESET,
  PASSWORD_FORGET,
  DOWNLOAD_APP_WITH_PRODUCT,
  ORG_THEME,
  NO_TEAM,
  PRODUCT_SCRAPER_TEST_PAGE,
  START_TRIAL,
  UGC_RIGHTS_MGMT,
  EMAIL_NOTIFICATIONS_UNSUBSCRIBED,
];

const ROUTES_WITH_HIDDEN_TOPBAR = [
  ...COMMON_HIDDEN_ROUTES,
  ORG_ONE_TO_MANY_HOME,
  ORG_ONE_TO_ONE_HOME,
  ORG_401,
  GLOBAL,
  CLIENTS,
  SAML_PROVIDERS,
  DASHBOARD_TRANSLATIONS,
  ORG_AGENT_TOOL,
  PRODUCT_ROUTES.ORG_CHAT_HOME,
  PRODUCT_ROUTES.ORG_CHAT_MANAGE_STORES,
  PRODUCT_ROUTES.ORG_CHAT_CMS_POSTS,
  PRODUCT_ROUTES.ORG_CHAT_ACCUONTS_OVERVIEW,
  PRODUCT_ROUTES.ORG_CHAT_CONFIG_STORE_APP,
  PRODUCT_ROUTES.ORG_CHAT_CONFIG_PLUGIN,
  PRODUCT_ROUTES.ORG_CHAT_CONFIG_RETAILER,
  PRODUCT_ROUTES.ORG_CHAT_CONFIG_PRODUCT_FEED,
  PRODUCT_ROUTES.ORG_CHAT_WEB_APP,
  PRODUCT_ROUTES.ORG_CHAT_WEB_APP_CHAT,
  PRODUCT_ROUTES.ORG_CHAT_WEB_APP_PROFILE,
  ...UPSELL_ROUTES,
];

const ROUTES_WITH_HIDDEN_PRODUCT_HEADER = [
  ...COMMON_HIDDEN_ROUTES,
  ORG_SHOW_MODERATE,
  ORG_SHOW_EDIT,
  ORG_ONE_TO_MANY_THEMING,
  ORG_ON_DEMAND_THEMING,
];

const ROUTES_WITH_HIDDEN_SIDEBAR = [
  ...COMMON_HIDDEN_ROUTES,
  ORG_SHOW_MODERATE,
  ORG_SHOW_EDIT,
  ORG_ONE_TO_MANY_THEMING,
  ORG_ON_DEMAND_THEMING,
];

const ROUTES_WITH_HIDDEN_PADDINGS = [
  ORG_SHOW_MODERATE,
  ORG_ON_DEMAND_HOME,
  ORG_ON_DEMAND_VIDEOS,
  ORG_ON_DEMAND_VIDEO_SETUP,
  ORG_ON_DEMAND_PRODUCTS,
  ORG_ON_DEMAND_PRODUCT_SETUP,
  ORG_ON_DEMAND_DISTRIBUTION_PAGES,
  ORG_ON_DEMAND_DISTRIBUTION_CONTAINERS,
  ORG_ON_DEMAND_DISTRIBUTION_CONTAINER,
  ORG_ON_DEMAND_GET_STARTED,
  ORG_ON_DEMAND_ACTIONS,
  ORG_ON_DEMAND_ACTIONS_SETUP,
  ORG_ON_DEMAND_VIDEOS_EDIT_NEW,
  ORG_ON_DEMAND_PLAYLISTS,
  ORG_ON_DEMAND_PLAYLISTS_EDIT,
  ORG_ON_DEMAND_PLACEMENTS,
  ORG_ON_DEMAND_PLACEMENTS_EDIT,
  ORG_ON_DEMAND_APPEARANCES,
  ORG_ON_DEMAND_APPEARANCES_EDIT,
  ORG_LOCALIZATION,
  ORG_LOCALIZATION_EDIT,
  ORG_EMBED_STATS,
  CLIENT_USAGE,
  ORG_CALL_BOOKING_SERVICES,
  ORG_API_KEYS,
  ORG_DATA_EXPORT_JOBS,
  ORG_ON_DEMAND_DATA_EXPORT_JOBS,
  ORG_FLOATING_WIDGET,
  ORG_FLOATING_WIDGET_SETTINGS,
  PRODUCT_ROUTES.ORG_CHAT_MANAGE_STORES,
  PRODUCT_ROUTES.ORG_CHAT_CMS_POSTS,
  PRODUCT_ROUTES.ORG_CHAT_ACCUONTS_OVERVIEW,
  PRODUCT_ROUTES.ORG_CHAT_CONFIG_STORE_APP,
  PRODUCT_ROUTES.ORG_CHAT_CONFIG_PLUGIN,
  PRODUCT_ROUTES.ORG_CHAT_CONFIG_RETAILER,
  PRODUCT_ROUTES.ORG_CHAT_CONFIG_PRODUCT_FEED,
  PRODUCT_ROUTES.ORG_CHAT_WEB_APP,
  PRODUCT_ROUTES.ORG_CHAT_WEB_APP_CHAT,
  PRODUCT_ROUTES.ORG_CHAT_WEB_APP_PROFILE,
  PRODUCT_ROUTES.ORG_CHAT_CONTACTS,
  PRODUCT_ROUTES.ORG_CHAT_DEPARTMENTS,
  ORG_USERS,
  CLIENT_USERS,
  ORG_STATS,
  ORG_PRODUCT_FEED,
  ORG_PRODUCT_FEED_ID,
  ORG_CALL_INSIGHTS,
  ORG_PRODUCTS,
  ORG_PRODUCTS_ID,
];
const ROUTES_WITH_HIDDEN_ALERT = [ORG_SHOW_MODERATE, ORG_AGENT_TOOL];

const ROUTES_WITH_FOOTER = [
  ORG_CALL_INSIGHTS,
];

const ROUTES_WITH_AICHATBOT = [
  ORG_ONE_TO_ONE_HOME,
  ORG_ONE_TO_MANY_HOME,
];

export const TOPBAR = 'topbar';
export const PRODUCT_HEADER = 'productHeader';
export const SIDEBAR = 'sidebar';
export const PADDINGS = 'paddings';

export const NavigationFrameContextProvider = (props) => {
  const location = useLocation();
  const [isSidebarCollapsed, setIsSidebarCollapsedPrivate] = useLocalStorage('sidebar_collapsed', false);
  const [didUserOverrideSidebar, setDidUserOverrideSidebar] = useState(false);
  const [isProductHeaderExpanded, setIsProductHeaderExpanded] = useState(false);
  const [selectedNavigationItemTitle, setSelectedNavigationItemTitle] = useState(null);
  const [subPageWidth, setSubPageWidth] = useState(SUB_PAGE_WIDTHS.SMALL);

  const setIsSidebarCollapsed = (collapsed) => {
    if (!didUserOverrideSidebar) setDidUserOverrideSidebar(true);
    setIsSidebarCollapsedPrivate(collapsed);
  };
  const setPreferSidebarCollapsed = (collapsed) => {
    if (!didUserOverrideSidebar) setIsSidebarCollapsedPrivate(collapsed);
  };

  const [overrideTopbar, setOverrideTopbar] = useState(null);
  const [overrideProductHeader, setOverrideProductHeader] = useState(null);
  const [overrideSidebar, setOverrideSidebar] = useState(null);
  const [overridePaddings, setOverridePaddings] = useState(null);
  const [overrideAlert, setOverrideAlert] = useState(null);

  const overrideShowFrame = useCallback((key, value) => {
    if (key === TOPBAR) setOverrideTopbar(value);
    if (key === PRODUCT_HEADER) setOverrideProductHeader(value);
    if (key === SIDEBAR) setOverrideSidebar(value);
    if (key === PADDINGS) setOverridePaddings(value);
  }, []);

  const shouldShowTopbar = useCallback(() => {
    if (overrideTopbar !== null) return overrideTopbar;
    const matchingPath = matchPath(location.pathname, { path: ROUTES_WITH_HIDDEN_TOPBAR, exact: true });
    const shouldShowTopbar = !matchingPath?.isExact;
    return shouldShowTopbar;
  }, [location.pathname, overrideTopbar]);

  const shouldShowFooter = useCallback(() => {
    const matchingPath = matchPath(location.pathname, { path: ROUTES_WITH_FOOTER, exact: true });
    return matchingPath?.isExact;
  }, [location.pathname]);

  const shouldShowProductHeader = useCallback(() => {
    if (overrideProductHeader !== null) return overrideProductHeader;
    const matchingPath = matchPath(location.pathname, { path: ROUTES_WITH_HIDDEN_PRODUCT_HEADER, exact: true });
    const shouldShowProductHeader = !matchingPath?.isExact;
    return shouldShowProductHeader;
  }, [location.pathname, overrideProductHeader]);

  const shouldShowSidebar = useCallback(() => {
    if (overrideSidebar !== null) return overrideSidebar;
    const matchingPath = matchPath(location.pathname, { path: ROUTES_WITH_HIDDEN_SIDEBAR, exact: true });
    const shouldShowSidebar = !matchingPath?.isExact;
    return shouldShowSidebar;
  }, [location.pathname, overrideSidebar]);

  const shouldShowPaddings = useCallback(() => {
    if (overridePaddings !== null) return overridePaddings;
    const matchingPath = matchPath(location.pathname, { path: ROUTES_WITH_HIDDEN_PADDINGS, exact: true });
    return !matchingPath?.isExact;
  }, [location.pathname, overridePaddings]);

  const canShowBillingAlert = useCallback(() => {
    if (overrideAlert !== null) return overrideAlert;
    const matchingPath = matchPath(location.pathname, { path: ROUTES_WITH_HIDDEN_ALERT, exact: true });
    return !matchingPath?.isExact;
  }, [location.pathname, overrideAlert]);

  const shouldShowAIChatBot = useCallback(() => {
    const matchingPath = matchPath(location.pathname, { path: ROUTES_WITH_AICHATBOT, exact: true });
    return matchingPath?.isExact;
  }, [location.pathname]);

  const isTopbarShown = shouldShowTopbar();
  const isProductHeaderShown = shouldShowProductHeader();
  const isSidebarShown = shouldShowSidebar();
  const contentHasPaddings = shouldShowPaddings();
  const canHaveBillingAlert = canShowBillingAlert();
  const canHaveAIChatBot = shouldShowAIChatBot();
  const isFooterShown = shouldShowFooter();

  const isSidebarExpanded = !!selectedNavigationItemTitle;

  const context = {
    isTopbarShown,
    isProductHeaderShown,
    isSidebarShown,
    canHaveBillingAlert,
    canHaveAIChatBot,
    contentHasPaddings,
    isSidebarCollapsed,
    setIsSidebarCollapsed,
    setPreferSidebarCollapsed,
    overrideShowFrame,
    isProductHeaderExpanded,
    setIsProductHeaderExpanded,
    isSidebarExpanded,
    selectedNavigationItemTitle,
    setSelectedNavigationItemTitle,
    subPageWidth,
    setSubPageWidth,
    isFooterShown,
  };

  return <NavigationFrameContext.Provider value={context}>{props.children}</NavigationFrameContext.Provider>;
};

export const useNavigationFrameContext = () => useContext(NavigationFrameContext);

export const withNavigationFrameContext = () => (Component) => {
  // We need to forward refs, otherwise refs will incorrectly reference this component and not the underlying component.
  const withNavigationFrameContextComponent = React.forwardRef((props, ref) => {
    const context = useNavigationFrameContext();

    return <Component ref={ref} {...context} {...props} />;
  });

  withNavigationFrameContextComponent.displayName = `withNavigationFrameContext(${getDisplayName(Component)})`;

  return withNavigationFrameContext;
};
